import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import {
  LOGIN_HERO_FEATURES,
  LOGIN_HERO_ORBS,
  REGISTER_HERO_FEATURES,
  REGISTER_HERO_ORBS,
  REGISTER_HERO_SUBTITLE_KEY
} from "../authData";

const AuthHero = ({ variant = "login" }) => {
  const { t } = useTranslation("common");
  const features = variant === "register" ? REGISTER_HERO_FEATURES : LOGIN_HERO_FEATURES;
  const orbs = variant === "register" ? REGISTER_HERO_ORBS : LOGIN_HERO_ORBS;
  const subtitleKey =
    variant === "register"
      ? REGISTER_HERO_SUBTITLE_KEY
      : "Generate, manage, and deploy enterprise-grade Odoo REST APIs in minutes — no backend coding required.";

  return (
    <div className="auth-hero">
      <div className="orb orb-blue" style={orbs.blue}></div>
      <div className="orb orb-purple" style={orbs.purple}></div>
      <div className="auth-hero-content">
        <h2>{t("Connect Odoo to anything with one API")}</h2>
        <p>{t(subtitleKey)}</p>
        <div className="feature-list">
          {features.map(({ icon, key }) => (
            <div key={key} className="feature-item">
              <div className="fi-icon">{icon}</div>
              <span>{t(key)}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

AuthHero.propTypes = {
  variant: PropTypes.oneOf(["login", "register"])
};

export default AuthHero;
